// extracted by mini-css-extract-plugin
module.exports = {"saveBookmarkButton":"saveBookmarkButton","saveBookmarkButton--loading":"saveBookmarkButton--loading"};